import "./ErrorScreen.scss";

export default function ErrorScreen({ message, sub, onAddNew, btnlink }) {
  return (
    <>
      <div className="d-flex flex-column" />
      <h5 className="error-screen__title card-title d-flex justify-content-center text-center mb-2">
        {message}
      </h5>
      {!sub ? (
        <div className="error-screen__sub grey-sub small-text d-flex justify-content-center text-center">
          Oops! Something went wrong on our end or no data. Please try again
          later.
        </div>
      ) : (
        sub !== "notification" && (
          <div className="error-screen__sub small-text d-flex justify-content-center text-center">
            {sub}
          </div>
        )
      )}
    </>
  );
}
